/**
 * Utility functions for component styling
 *
 * @fileoverview Helper functions for class name management (cn utility)
 * Used by shadcn/ui components
 *
 * @changeHistory
 * - 2024-12-03: Initial creation - Added cn utility for class merging (GitHub Copilot)
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with proper precedence
 *
 * @param inputs - Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Format a date string or Date object to a readable string
 *
 * @param date - Date string or object
 * @returns Formatted date string (e.g., "Jan 1, 2024")
 */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
